var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21,
    viewBox: "0 0 25 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56 1c-.844 0-1.643.17-2.375.507-1.426.656-2.462 1.793-2.918 3.199-.56 1.728-.237 3.727.934 5.782 1.675 2.948 4.72 5.287 9.768 9.163l.301.232.291-.223c5.052-3.88 8.102-6.224 9.777-9.172 1.171-2.055 1.495-4.054.934-5.782-.455-1.406-1.491-2.543-2.916-3.199a5.64 5.64 0 0 0-2.375-.506c-2.284 0-4.412 1.27-5.296 3.162l-.415.888-.415-.888C10.971 2.27 8.843 1 6.56 1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c2233",
    d: "M6.56 1c-.844 0-1.643.17-2.375.507-1.426.656-2.462 1.793-2.918 3.199-.56 1.728-.237 3.727.934 5.782 1.675 2.948 4.72 5.287 9.768 9.163l.301.232.291-.223c5.052-3.88 8.102-6.224 9.777-9.172 1.171-2.055 1.495-4.054.934-5.782-.455-1.406-1.491-2.543-2.916-3.199a5.64 5.64 0 0 0-2.375-.506c-2.284 0-4.412 1.27-5.296 3.162l-.415.888-.415-.888C10.971 2.27 8.843 1 6.56 1z"
  }))));
};
export default SvgHeart;